import classNames from 'classnames';
import React from 'react';
import BsForm from 'react-bootstrap/Form';

type ErrorProp = boolean | string | string[] | Error;

export interface FormUnitProps {
  readonly groupStyle?: React.CSSProperties;
  readonly groupClassName?: string;
  readonly label?: React.ReactNode;
  readonly error?: ErrorProp;
  readonly hint?: React.ReactNode;
  readonly markRequired?: boolean;
  readonly children: React.ReactNode;
  readonly id?: string;
}

export function FormLabel(p: {
  markRequired?: boolean;
  children?: React.ReactNode;
  htmlFor?: string;
}) {
  if (!p.children) {
    return null;
  }

  return (
    <BsForm.Label htmlFor={p.htmlFor}>
      {p.markRequired && '* '} {p.children}
    </BsForm.Label>
  );
}

export function FormError(p: { error?: ErrorProp }) {
  if (!p.error) {
    return null;
  }

  return (
    <BsForm.Control.Feedback type="invalid" style={{ display: 'block' }}>
      {(() => {
        if (p.error === true) {
          return 'Error';
        }

        if (p.error instanceof Error) {
          return p.error.message;
        }

        if (typeof p.error === 'string') {
          return p.error;
        }

        return p.error.map((err) => <span>{err}. </span>);
      })()}
    </BsForm.Control.Feedback>
  );
}

export function FormHint(p: { hint: React.ReactNode }) {
  if (!p.hint) {
    return null;
  }

  return <BsForm.Text className="text-muted">{p.hint}</BsForm.Text>;
}

export const FormUnit = (props: FormUnitProps) => {
  const { groupClassName, groupStyle, label, error, markRequired, hint, children, id } = props;

  return (
    <BsForm.Group
      className={classNames(groupClassName, markRequired && 'is-required')}
      style={groupStyle}
    >
      <FormLabel children={label} markRequired={markRequired} htmlFor={id} />
      {children}
      <FormError error={error} />
      <FormHint hint={hint} />
    </BsForm.Group>
  );
};
